"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const objDia = {
    data: yup.date().label('Data'),
    aula: yup.string().label('Nr da aula'),
    observacao: yup.string().label('Observação do dia de aula'),
    inutilizarColuna: yup.boolean().label('Inutilizar coluna do dia de aula'),
};
const yupDias = yup.object(objDia);
const objMatricula = {
    nome: yup.string().required().label('Nome do aluno'),
    dataNascimento: yup.date().label('Data de nascimento do aluno'),
    genero: yup.string().required().label('Genêro do aluno'),
    codigo: yup.string().required().label('Código do aluno'),
    nrChamada: yup.string().required().label('Número de chamada do aluno'),
    historico: yup.string().label('Histórico da matrícula'),
    media: yup.string().label('Média do aluno'),
    nota: yup.string().label('Nota do aluno'),
    recuperacao: yup.string().label('Nota de recuperação do aluno'),
    faltasCalculadas: yup.string().required().label('Faltas falculadas'),
};
const yupMatricula = yup.object(objMatricula);
const yupDiario = yup.object(Object.assign(Object.assign(Object.assign({}, objDia), objMatricula), { presenca: yup.string().label('Presença do aluno') }));
